// รายการรถทั้ง 2 ชุดเรียก Laravel `/getlistvehiclehoneytoast` เอง — body เดียวกับหน้าเดิม แต่ไม่ผ่าน redux / saga ของหน้าเดิม

import { useCallback, useEffect, useRef, useState } from 'react'

const ENDPOINT = process.env.REACT_APP_LARAVEL_API_ENDPOINT

export const ALL_STATUS = [
  'running',
  'stop-with-engine-on',
  'stop-with-engine-off',
  'connection-error',
]

function postVehicles(auth, body) {
  const { profile, accessToken } = auth
  return fetch(`${ENDPOINT}/getlistvehiclehoneytoast`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      vehicle_visibility: profile.vehicle_visibility,
      company_id: profile.company_id,
      ...body,
    }),
  })
    .then(res => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
    .then(json => (json && Array.isArray(json.data) ? json.data : []))
}

/** รายการด้านซ้ายของหน้า — คำตอบที่มาช้ากว่ารอบใหม่ถูกทิ้ง */
export function useWallVehicles(auth) {
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(false)
  const seq = useRef(0)

  const load = useCallback(
    body => {
      const n = ++seq.current
      setLoading(true)
      return postVehicles(auth, body)
        .then(list => {
          if (n === seq.current) setVehicles(list)
          return list
        })
        .finally(() => {
          if (n === seq.current) setLoading(false)
        })
    },
    [auth],
  )

  return { vehicles, loading, load }
}

/** ตัวเลือกรถในหน้าต่างตัวกรอง — ตามหน่วยงานที่เลือก · ทุกสถานะ */
export function useFilterVehicles(auth, org) {
  const [options, setOptions] = useState([])
  const seq = useRef(0)

  useEffect(() => {
    const n = ++seq.current
    postVehicles(auth, {
      list_vehicle_id: '',
      orderBy: 'plate_no',
      orderType: 'asc',
      selectedDivision: org.division,
      selectedDepartment: org.department,
      selectedSection: org.section,
      selectedPlant: org.plant,
      vehicleStatus: ALL_STATUS,
    })
      .then(list => {
        if (n === seq.current) setOptions(list)
      })
      .catch(() => {})
  }, [auth, org])

  return options
}
